export const messages = {
  0: 'Ошибка общего характера. Попробуйте позже или обратитесь к администратору',
  10: 'Необходимо заполнить договор!',
  20: 'Данная операция не производилась',
  30: 'Ошибка в данных. Пожалуйста, проверьте введенный логин и пароль',
  40: 'Ошибка! Пользователь с такими данными уже в программе',
  50: 'Ошибка! Пользователь отключен',
  60: 'Срок действия доверенности истек',
  500: '',
  503: 'Сумма выходит за пределы выбранного купона.',
  12001: 'Клиент с таким идентификационным номером или номером документа уже существует!',
  12002: 'Список документов клиента не должен быть пустым!',
  12003: 'Список адресов клиента не должен быть пустым!',
  12004: 'Список контактов клиента не должен быть пустым!',
  12005: 'Ошибка! Срок действия документа истек или документ неактивен.',
  13001: 'Подразделение с таким номером или названием уже существует!',
  14001: 'Филиал с таким названием уже существует!',
  13100: 'Ошибка чтения данных из файла JSON',
  13101: 'Ошибка при создании inputStream из файла',
  13103: 'Ошибка при создании Exel из файла',
  13104: 'Ошибка чтения данных из Zip-архива',
  14002: 'Некорректная категория купона',
  14004: 'Внутренняя ошибка, обратитесь к администратору',
  14005: 'Данный пользователь не может получить информацию о выбранном подразделении',
  14006: 'Диапазоны купонов в одной категории не должны пересекатьcя',
  14401: 'Обещанную дату выкупа можно применить только один раз',
  15001: 'Основание с таким кодом уже существует!',
  15100: 'Администратор не может снять роль администратора с себя',
  15150: 'Такая марка авто уже существует',
  15151: 'Такая модель авто уже существует',
  15152: 'Ошибка сохранения авто в базу данных',
  15154: 'Ошибка редактирования авто в базе данных',
  15399: 'Сумма в "Доступно" должна быть больше или равна нулю',
  16003: 'Не найдено ни одного договора из запроса',
  16004: 'Неизвестный статус для перевода',
  16005: 'Невозможно изменить статус с определённого на определённый',
  16006: 'Дирекция уже существует',
  16007: 'Дирекция не выбрана',
  16008: 'Автоломбард уже существует',
  16010: 'Нельзя изменить статус на ИНВЕНТАРЬ или МАГАЗИН, если это не вещь или дней просрочки меньше, чем 31',
  16011: 'Нельзя изменить статус на ГОХРАН, если это не драг.металл или дней просрочки меньше, чем 31',
  16012: 'Для возврата в магазин должен быть выбран один договор',
  16013: 'Достигнут максимальный срок возврата товара - 2 месяца',
  16014: 'Только администратор может выбрать Отказ от выкупа',
  16200: 'Общий вес должен быть больше или равен лигатурному',
  16201: 'Купон неактивный, выберите новый купон',
  16202: 'Сумма выходит за пределы купона',
  16203: 'Дата договора выходит за пределы купона',
  16204: 'Для купона на 1 день, должен быть отмечен отказ от выкупа',
  16205: 'Введены неправильные диапазоны сумм',
  16220: 'Не найдены объединяемые анкеты',
  16222: 'Не найдены объединяемые анкеты',
  16223: 'Документ просрочен',
  16224: 'Дата выдачи должна быть до сегодняшнего числа',
  16225: 'Ошибка! Нельзя активировать пользователя без активной роли',
  16230: 'Сумма меньше чем требуется',
  16231: 'Введенная сумма больше доступной',
  16300: 'Операция не найдена',
  16301: 'Операция не найдена в договоре',
  16302: 'Невозможно отменить перевод статуса "просрочен"',
  16303: 'Невозможно отменить создание договора',
  16304: 'Операция уже отменена',
  16305: 'Невозможно отменить операцию отмены',
  16306: 'Договор не найден',
  16307: 'Отмена аннулирования сделки сформированной с помощью «Изменение суммы», запрещена!',
  16308: 'Транзакция по передаче в ГоХран не была произведена',
  16310: 'Операция не может быть отменена из-за активных операций после',
  16311: 'Достигнуто максимальное количество операции “Отмена”',
  16312: 'Превышено время для возврата операции',
  16313: 'Невозможно редактировать подразделение ранее перемещенного договора',
  16399: 'Договор может быть создан только с активным документом у клиента',
  16400: 'Договор может быть создан только для активных клиентов с действительным документом',
  16401: 'Неверная страна для документа нерезидента',
  16402: 'Неверное гражданство для клиента нерезидента',
  16403: 'Машина находится в гараже менее 30 дней',
  16407: 'Договор активен. Выбранная дата продления меньше даты окончания договора',
  16409: 'Дата договора не соответствует установленным срокам',
  16410: 'Договор может быть продлен только на',
  16411: 'Договор не может быть продлен датой в прошлом',
  16412: 'Ошибка создания договора. Название подразделения должно содержать символ "№"',
  16413: 'Ошибка в запросе последнего номера транзакций для удаленного пользователя',
  16414: 'Длинна имени подразделения после транслитерации больше 14 символов. Уменьшите имя и попробуйте ещё раз',
  16415: 'Недостаточно средств для оплаты процентов',
  16416: 'Выбранная дата не соответствует возможным датам продления',
  16417: 'Выбранная дата не соответствует возможным датам продления',
  16451: 'Транзакция находится в другом подразделении',
  16500: 'Договор не найден',
  16501: 'Ошибка валидации. Проверьте введенные данные',
  16503: 'Нужно отменить переоценку перед редактированием оценочной стоимости',
  16408: 'Договор должен быть в том же подразделении, что и пользователь',
  16504: 'Ошибка валидации. Пожалуйста, проверьте введенные данные',
  16506: 'Введённый номер договора уже существует',
  16511: 'Перед аннулированием необходимо отменить операции',
  16512: 'Билет может быть отменён только в день создания',
  16513: 'Договор имеет статус "Отменён" или "Аннулирован"',
  16514: 'Эта операция может быть выполнена только пользователем с ролью администратора',
  16520: 'Договор не найден',
  16521: 'Запрошенного подразделения не существует',
  16522: 'Запрашиваемые договоры отсутствуют в базе',
  16523: 'Договор или накладная должны быть в том же подразделении, что и пользователь',
  16529: 'Ошибка при выполнении операции уценки',
  16530: 'Не указан тип операции (нал/безнал)',
  16531: 'Выбраны договора разных типов',
  16532: 'Выбранные машины не находятся в гараже',
  16533: 'Машина находится в гараже менее 30 дней',
  16550: 'Один из договоров имеет статус "Отменён"',
  16551: 'Договор имеет статус "На передаче"',
  16552: 'Договор имеет статус "В гараже"',
  16660: 'Основание с таким названием уже существует',
  16631: 'Невозможно закрыть договор будущей датой',
  16632: 'Поле Выдать не должно быть пустым',
  16605: 'Необратимая транзакция',
  16606: 'Транзакция находится в другом подразделении',
  16607: 'Дата транзакции не находится в допустимом диапазоне для возврата для текущего пользователя',
  16608: 'Транзакция не найдена',
  16645: 'Нельзя сохранить договор в деактивированное подразделение',
  16700: 'Ошибка при создании отчета',
  16701: 'Ошибка кодировки windows-1251',
  16702: 'Оштбка при создании XML документа',
  17102: 'Ошибка. Клиент не найден',
  17003: 'Такой личный номер уже существует в системе',
  17101: 'Ошибка получения данных из клиент сервиса',
  16800: 'Максимальный размер файла 5 Мб',
  16801: 'Наименование рекламной вставки должно содержать не более 40 символов, включая наименование расширения',
  16802: 'Наименование рекламной вставки содержит некорректные символы',
  16803: 'Рекламная вставка должна быть в формате jpg / jpeg',
  17107: 'Ошибка! Выбран неподходящий файл.',
  18107: 'Купон сейчас недоступен (ограничение по времени)',
  18108: 'Не выбрано время от или до',
  19000: 'Отказ в займе: достигнута максимально допустимая сумма выдачи займов с превышением значения ПДН. Перепроверьте данные анкеты или измените сумму займа.',
  19001: 'Отказ в займе: превышен размер БПМ.',
  19002: 'Отказ в займе: недостаточный уровень дохода для выполнения обязательств по займу',
  19003: 'Отсутствует название области в адресе клиента',
  20001: 'Сумма депозита больше суммы платежей. Необходимо закрыть договор.',
  20003: 'Последний платеж не был произведен. Необходимо закрыть договор.',
  20002: 'Превышен лимит процентов. Уменьшите срок выдачи.',
  20005: 'Запросите оценочную стоимость, меньшую, чем желаемая сумма'
}
